export enum ArticleCategory {
  GENERAL = 'general',
  BUSINESS = 'business',
  HEALTH = 'health',
  SCIENCE = 'science',
  SPORTS = 'sports',
  TECHNOLOGY = 'technology',
  FAVORITES = 'favorites',
}
